/**
 * SignInForm Component
 * 
 * Form component for sign-in with email and password.
 * Includes organization signup link.
 */

import { useNavigate } from 'react-router-dom';
import { ImagoInput } from '../../../shared/components/ui/ImagoInput';
import { ImagoButton } from '../../../shared/components/ui/ImagoButton';
import { PasswordInput } from '../../../shared/components/ui/PasswordInput';
import { ROUTES } from '../../../shared/utils/constants';

/**
 * SignInForm component
 * @param {Object} props
 * @param {string} props.email - Email value
 * @param {string} props.password - Password value
 * @param {Function} props.onEmailChange - Email change handler
 * @param {Function} props.onPasswordChange - Password change handler
 * @param {Function} props.onSubmit - Form submit handler
 * @param {boolean} [props.isLoading] - Loading state
 */
export function SignInForm({
  email,
  password,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  isLoading = false,
}) {
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    onEmailChange(e.target.value);
  };

  // Auth-specific input styles
  const authInputStyle = {
    backgroundColor: 'var(--color-card)',
    borderColor: 'var(--color-input-border)',
  };

  return (
    <form className="flex flex-col" onSubmit={onSubmit} autoComplete="off">
      <ImagoInput
        id="team-domain"
        type="email"
        label="Email"
        placeholder="e.g. supriya@project.com"
        value={email}
        onChange={handleEmailChange}
        required
        autoComplete="nope"
        className="mb-4 tracking-wide"
        inputClassName="text-xs px-2.5 py-3"
        style={authInputStyle}
      />

      <PasswordInput
        id="password"
        label="Password"
        placeholder="Enter your password"
        value={password}
        onChange={onPasswordChange}
        required
        autoComplete="off"
        className="mb-4 tracking-wide"
        inputStyle={authInputStyle}
      />

      {/* <div className="flex items-center mb-4">
        <input
          type="checkbox"
          id="stay-signed-in"
          className="mr-2 w-4 h-4"
        />
        <label
          htmlFor="stay-signed-in"
          className="text-xs"
          style={{ color: 'var(--color-foreground)' }}
        >
          Stay signed in
        </label>
      </div> */}

      <ImagoButton
        type="submit"
        variant="primary"
        size="md"
        loading={isLoading}
        disabled={isLoading}
        className="w-full mt-4 text-xs py-3"
        style={{ backgroundColor: 'var(--color-primary)' }}
      >
        Continue
      </ImagoButton>

      <p
        className="text-center text-xs mt-6"
        style={{ color: 'var(--color-muted)' }}
      >
        Don't have an account?{' '}
        <button
          type="button"
          onClick={() => navigate(ROUTES.SIGN_UP)}
          className="font-medium hover:underline"
          style={{ color: 'var(--color-primary)' }}
        >
          Sign Up
        </button>
      </p>
    </form>
  );
}

export default SignInForm;
